export const getTwilioGenericType = (mime) => {
  if (!mime) return 'text';
  if (mime.includes('image')) return 'photo';
  return 'file';
};
